import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'translateDay',
    standalone: false
})
export class TranslateDayPipe implements PipeTransform {

  transform(day: string): string {
    // You can replace the English day names with their corresponding Hebrew names
    const translations = {
      Sunday: 'ראשון',
      Monday: 'שני',
      Tuesday: 'שלישי',
      Wednesday: 'רביעי',
      Thursday: 'חמישי',
      Friday: 'שישי',
      Saturday: 'שבת'
    };
 
    return translations[day] || day;
  }

}
